<template>
  <b-container>
    <p>&nbsp;</p>
    <b-row>
      <b-col>
        <b-tabs>
          <b-tab title="模型管理" active>
            <ModelList/>
          </b-tab>
          <b-tab title="訓練資料管理">
            <DatasetList/>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DatasetList from './components/DatasetList.vue';
import ModelList from './components/ModelList.vue';

export default {
  name: 'App',
  components: { DatasetList, ModelList }
};
</script>
<style lang="scss" scoped>
  .container {
    max-width: 100%;
  }
</style>
